import React, { useEffect, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Button } from 'primereact/button'
import { Toast } from 'primereact/toast'
import { Link, useNavigate } from 'react-router-dom'
import * as auth from "infra/localStorage"
import server from 'infra/server.js'
import LoginService from './loginService'

export default function Empresa() {

    const [loginService] = useState(new LoginService())
    const [empresa, setEmpresa] = useState([])
    const navigate = useNavigate()
    const toast = useRef(null)
    let selected = ''
    const defaultValues = []
    const form = useForm({ defaultValues })
    const errors = form.formState.errors

    const [loading, setLoading] = useState(false)
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768 || window.innerHeight < 420)

    useEffect(() => {
        document.body.style.backgroundColor = '#ffffff'
        return () => {
            document.body.style.backgroundColor = ''
        }
    }, [])

    // Depois de montada a tela.
    useEffect(() => {

        const http = server()

        http.get('empresa')
            .then((response) => {
                setEmpresa(response.data)
            })
    }, [])

    // Salva.
    const onSubmit = _ => {

        setLoading(true)

        const http = server()
        http.post('empresa', { "codigo": selected }
        ).then(async _ => {
            const storageData = auth.getData()
            const emp = empresa.find((emp) => emp.codigo_emp == selected)
            storageData.empresa.codigo_emp = emp.codigo_emp
            storageData.empresa.nome_razao_pes = emp.nome_razao_pes
            storageData.empresa.nome_fantasia_pej = emp.nome_fantasia_pej
            storageData.menu = await loginService.getMenu()
            auth.setData(storageData)

            form.reset()
            navigate('/')
        }).catch((err) => {
            console.error(err)

            let detail = 'Problemas ao prosseguir, resive os cadastros!'
            if (err?.response?.data) {
                detail = err?.response?.data
            }
            toast.current.show({ severity: 'error', summary: 'Ops!', detail, life: 7000 })

            setLoading(false)

        })

    }

    const getFormErrorMessage = (name) => {
        return errors[name] ? <small className="p-error">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>
    }

    return (

        <div id='empresaspage' className="flex flex-column md:flex-row bg-white h-screen">

            {/* Esquerda: Branding */}
            {isMobile ? (
                <></>
            ) : (
                < div className="md:w-6 border-0" >
                    <img src="/login-sup-esq.svg" className='border-0' alt="Arte superior esquerda" />
                    <div className='flex border-0 absolute' style={{ top: '50%', left: '25%' }}>
                        <img src="/logo.svg" className='' alt="Logo" style={{ width: '15%' }} />
                        <div>
                            <div className='text-7xl ml-4'>Fiz Aqui</div>
                            <div className='ml-5 mt-1 text-gray-400'>Enterprise Resource Planning</div>
                        </div>
                    </div>
                </div>
            )}

            {/* Direita: Formulário */}
            <div className={`border-0 w-full md:w-${isMobile ? 12 : 6} flex flex-column align-items-center`}>

                {/* Cabeçalho */}
                <div className="border-0 pb-8 border-green-500 p-0 w-full flex flex-column align-items-end relative">

                    <img className="absolute" src="/login-sup-dir.svg" alt="Arte superior direira" />
                    <div className="absolute flex flex-nowrap mt-2 mr-4 ext-white text-lg">
                        <Link id='redefinePassword' to="/redefinirsenha" className="text-white no-underline">Esqueci minha senha</Link>
                        <div className='mx-2 text-white'>|</div>
                        <Link id='addExtraBase' to="/adicionabaseextra" className="text-white no-underline">Adicionar base</Link>
                    </div>

                </div>

                {/* Formulário */}
                <div className="border-0 border-round h-full w-full flex flex-column align-items-center justify-content-center">

                    <div className='flex flex-column border-0 shadow-0 justify-content-center align-items-center border-round-2xl bg-white w-20rem'>

                        <Toast ref={toast} />
                        <h2 className="flex flex-row justify-content-start align-items-center text-900 mb-5">
                            <img src="/logo.svg" className='' alt="Logo" style={{ width: '9%' }} />
                            <div className='ml-2 font-light'>Selecione uma Empresa</div>
                        </h2>

                        <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-column align-items-left">

                            {empresa.map((e) => {
                                return <Controller
                                    key={e.nome_razao_pes}
                                    name={e.nome_razao_pes}
                                    control={form.control}
                                    rules={{ required: false }}
                                    defaultValue=""
                                    render={(form) => (
                                        <>
                                            <Button
                                                itemID='butEmpresa'
                                                key={form.field.name}
                                                label={e.codigo_emp + ' - ' + e.nome_fantasia_pej}
                                                type="submit"
                                                onClick={_ => selected = e.codigo_emp}
                                                id={form.field.name}
                                                {...form.field}
                                                icon={loading ? "pi pi-spin pi-cog" : "pi pi-home"}
                                                className="w-full font-bold bg-logo-main border-logo-main line-height-4 text-white border-2 border-solid border-round-2xl w-20rem"
                                            />
                                            {getFormErrorMessage(form.field.name)}
                                        </>
                                    )}
                                />
                            })}

                            {/* Links adicionais */}
                            <div className="text-right mt-4">
                                <Link id='login' to="/login" className="text-logo-main no-underline">Acessar com outra conta</Link>
                            </div>

                        </form>

                    </div>

                </div>

            </div>

        </div>
    )
}
